import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LoanApplicationService } from 'src/app/core/services/loan-application/loan-application.service';
import { VehicleApiService } from 'src/app/core/services/mobile-api/vehicle-api/vehicle-api.service';
import { RoutingPathsEnum, RoutingService } from 'src/app/core/services/routing/routing.service';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';
import {
	IVehicleListEntity,
	IVehicleListResponse,
	IVinInformation
} from 'src/app/core/services/mobile-api/vehicle-api/vehicle-api.model';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { VehicleFormComponent } from '../vehicle-form/vehicle-form.component';

@Component({
	selector: 'op-vehicle-list',
	templateUrl: './vehicle-list.component.html',
	styleUrls: ['./vehicle-list.component.scss']
})
export class VehicleListComponent implements OnInit {
	vehicles: IVehicleListEntity[] = [];

	@Output()
	vinResults = new EventEmitter<IVinInformation>();

	show: boolean = false;

	constructor(
		private vechileApiService: VehicleApiService,
		private loanAppService: LoanApplicationService,
		private translocoService: TranslocoService,
		private routingService: RoutingService,
		private tagDataService: TagDataService,
		public dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.loadVehicles();
	}

	private loadVehicles(): void {
		const loanId = this.loanAppService.loanApplicationId;

		this.vechileApiService.getValidVehicles(loanId).subscribe({
			next: (response: IVehicleListResponse) => {
				if (Array.isArray(response.vehicles) && response.vehicles.length) {
					this.vehicles = response.vehicles;
				} else {
					this.navigate();
				}
			},
			error: (err) => {
				this.navigate();
			}
		});
	}

	navigate(): void {
		this.routingService.route(RoutingPathsEnum.vehicle);
	}

	selectVehicle(vin: string, vendorName: string, vendorVehicleId: number): void {
		this.vechileApiService.getVehicleVin(vin).subscribe({
			next: (rsp) => {
				const dialogRef = this.dialog.open(VehicleFormComponent, {
					data: { vin: vin, vinResults: rsp, vendorName: vendorName, vendorVehicleId: vendorVehicleId }
				});
				return dialogRef.afterClosed().pipe(take(1));
			},
			error: (err) => {}
		});
	}
}
